
import { createContext, useContext } from 'react';

const ProjectFormContext = createContext();

export const ProjectFormProvider = ({ children, formData, logo, coverImages }) => {
  const value = {
    formData,
    logo,
    coverImages,
  };

  return (
    <ProjectFormContext.Provider value={value}>
      {children}
    </ProjectFormContext.Provider>
  );
};

export const useProjectForm = () => {
  const context = useContext(ProjectFormContext);
  if (!context) {
    throw new Error('useProjectForm must be used within ProjectFormProvider');
  }
  return context;
};
